var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSatellite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    color: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66666 15.1203V14.4537C10.9667 14.4537 12.0673 14.0032 12.9687 13.1023C13.87 12.201 14.3207 11.1003 14.3207 9.80033H14.9873C14.9873 10.5394 14.8482 11.2323 14.57 11.879C14.2918 12.5257 13.9131 13.0885 13.434 13.5677C12.9549 14.0468 12.392 14.4254 11.7453 14.7037C11.0987 14.9819 10.4058 15.1203 9.66666 15.1203ZM9.66666 12.865V12.1983C10.3333 12.1983 10.8995 11.9654 11.3653 11.4997C11.8311 11.0339 12.064 10.4677 12.064 9.80099H12.7307C12.7307 10.6463 12.4313 11.3683 11.8327 11.967C11.234 12.5657 10.512 12.865 9.66666 12.865ZM8.29866 10.541L6.61799 8.86366L5.67666 9.80499L7.36999 11.4817L4.08466 14.7677L0.291992 10.979L3.58199 7.69299L5.25866 9.38633L6.19999 8.44633L4.52332 6.75633L6.62533 4.65366L8.30266 6.33366L9.24333 5.39233L7.56666 3.69899L10.8487 0.416992L14.6373 4.20566L11.3553 7.48766L9.66199 5.81033L8.72066 6.75166L10.41 8.42833L8.29866 10.541ZM1.24333 10.9957L4.08466 13.837L5.04133 12.8803L2.19999 10.039L1.24333 10.9957ZM5.46333 12.4457L6.41933 11.4897L3.57799 8.64833L2.62199 9.60499L5.46333 12.4457ZM8.50132 3.69966L11.342 6.54099L12.2987 5.58433L9.45799 2.74299L8.50132 3.69966ZM12.7333 5.16166L13.69 4.20566L10.8487 1.36433L9.89199 2.32099L12.7333 5.16166Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatellite);
export default __webpack_public_path__ + "static/media/satellite.9ae83501.svg";
export { ForwardRef as ReactComponent };